import { styled } from "@mui/material/styles"
import Typography from "@mui/material/Typography"
import { Link as L2RLink } from "react-router-dom"

import { LockOutlinedIcon } from "@l2r-front/l2r-icons"

import { styledForMobile } from "../../utils/styledForMobile"

type KpiCardProps = {
    disabled?: boolean
}
export const KpiCard = styled(L2RLink, { shouldForwardProp: (prop) => prop !== "disabled" })<KpiCardProps>(({ disabled = false, theme }) => ({
    underline: "none",
    textDecoration: "none",
    alignItems: "center",
    backgroundColor: "white",
    transform: "scale(0.98)",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
        backgroundColor: "white",
        transform: !disabled && "scale(1)",
        transition: "0.2s",
    },
    borderRadius: 16,
    boxShadow: theme.customShadow("LCS/Shadow-simple"),
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(6),
    width: "100%",
    color: theme.palette["common/black_states"].main,
}))

export const Dummy = styled("span")(() => ({
    flexGrow: 1,
}))

export const IconWrapper = styledForMobile("div")(({ theme, isMobile }) => ({
    height: "30%",
    width: "100%",
    marginTop: isMobile ? theme.spacing(4) : "auto",
    marginBottom: theme.spacing(isMobile ? 4 : 5),
    flexShrink: 1,

    "& svg": {
        width: "100%",
        height: "100%",
    },
}))

export const Title = styledForMobile(Typography)(({ isMobile, theme }) => ({
    color: theme.palette["common/black_states"].main,
    marginTop: isMobile ? 0 : "auto",
    marginBottom: isMobile ? "auto" : theme.spacing(2),
    flexShrink: 1,
    textAlign: "center",
}))

export const Data = styledForMobile(Typography)(({ isMobile, theme }) => ({
    color: theme.palette["common/black_states"].main,
    marginTop: isMobile ? 0 : "auto",
    marginBottom: theme.spacing(isMobile ? 4 : 5),
    flexShrink: 1,
}))

export const KpiCardDisabledOverlay = styled("div")(() => ({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: 16,
    backdropFilter: "blur(5.5px)",
    zIndex: 1,
}))

export const IconWrapperDisabled = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 70,
    height: 70,
    borderRadius: 16,
    backgroundColor: theme.palette["gray/500"].main,
    zIndex: 1,
}))

export const LockedIcon = styled(LockOutlinedIcon)(() => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 2,
    height: 40,
    width: 40,
}))

export const ContentWrapper = styled("div")(() => ({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    position: "relative",
    width: "100%",
}))

export const TitleWrapper = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(3),
    justifyContent: "flex-start",
    width: "100%",
}))

const COUNT_SIZE = 28

export const Count = styled("div")(({ theme }) => ({
    alignItems: "center",
    borderRadius: "50%",
    backgroundColor: theme.palette["info"].light,
    display: "flex",
    height: COUNT_SIZE,
    justifyContent: "center",
    padding: theme.spacing(3),
    width: COUNT_SIZE,
}))

export const CardTitle = styledForMobile(Typography)(() => ({}))